import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Home from "./pages/Home";
import ProductDetail from "./pages/ProductDetail";
import CustomDesign from "./pages/CustomDesign";
import GroupOrders from "./pages/GroupOrders";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import TShirts from "./pages/TShirts";
import Polos from "./pages/Polos";
import HoodiesSweatshirts from "./pages/HoodiesSweatshirts";
import CupsDrinkware from "./pages/CupsDrinkware";
import BusinessPrinting from "./pages/BusinessPrinting";
import PersonalizedGifts from "./pages/PersonalizedGifts";
import CustomBoxes from "./pages/CustomBoxes";
import About from "./pages/About";
import Blog from "./pages/Blog";
import HowItWorks from "./pages/HowItWorks";
import Contact from "./pages/Contact";
import OurWork from "./pages/OurWork";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import Admin from "./pages/Admin";
import { Toaster } from "./components/ui/toaster";
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";
import CartDrawer from "./components/CartDrawer";
import Wishlist from "./pages/Wishlist";
import DesignStudio from "./pages/DesignStudio";
import MarketingWebsites from "./pages/MarketingWebsites";
import Community from "./pages/Community";
import CaseStudy from "./pages/CaseStudy";
import WebsitePackage from "./pages/WebsitePackage";
import GrowYourTeam from "./pages/GrowYourTeam";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => { if (!hash) window.scrollTo(0, 0); }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CartProvider>
          <WishlistProvider>
            <Routes>
              <Route path="/" element={<MarketingWebsites />} />
              <Route path="/home" element={<Home />} />
              <Route path="/community" element={<Community />} />
              <Route path="/portfolio/:slug" element={<CaseStudy />} />
              <Route path="/websites/:slug" element={<WebsitePackage />} />
              <Route path="/grow-your-team" element={<GrowYourTeam />} />
              <Route path="/shop/:slug" element={<ProductDetail />} />
              <Route path="/custom-design" element={<CustomDesign />} />
              <Route path="/group-orders" element={<GroupOrders />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order/:orderNumber" element={<OrderSuccess />} />
              <Route path="/t-shirts" element={<Home />} />
              <Route path="/t-shirts/collection" element={<TShirts />} />
              <Route path="/polos" element={<Polos />} />
              <Route path="/hoodies-sweatshirts" element={<HoodiesSweatshirts />} />
              <Route path="/cups" element={<CupsDrinkware />} />
              <Route path="/business-printing" element={<BusinessPrinting />} />
              <Route path="/gifts" element={<PersonalizedGifts />} />
              <Route path="/custom-boxes" element={<CustomBoxes />} />
              <Route path="/about" element={<About />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/how-it-works" element={<HowItWorks />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/our-work" element={<OurWork />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/design/:slug" element={<DesignStudio />} />
            </Routes>
            <CartDrawer />
          </WishlistProvider>
        </CartProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
